var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-box"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.page.pageNum,"page-sizes":[10, 30, 50, 100],"page-size":_vm.page.pageSize,"layout":"total,prev, pager, next, sizes, jumper","total":_vm.page.total},on:{"size-change":_vm.pageSizeChange,"current-change":_vm.pagecCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }